/**
 * 商品接口
 */

import request from './request';

export default {
    /**
     * 优惠券列表
     */
    discountList: model => request.post('discountList', model, { no: true }),
    /**
     * 添加优惠券
     */
    addDiscount: model => request.post('addDiscount', model),
    /**
     * 修改优惠券
     */
    editDiscount: model => request.post('editDiscount', model),
    /**
     * 删除优惠券
     */
    removeDiscount: discountId => request.post('removeDiscount', { discountId }),
    /**
     * 下架优惠券
     */
    offLineDiscount: model => request.post('offLineDiscount', model),
    /**
     * 上架优惠券
     */
    onLineDiscount: model => request.post('onLineDiscount', model),
    /**
     * 根据店铺商品分类查询商品
     */
    commodityListByShopCategory: shopCategoryId => request.get('shop/commodity/category/commodity/list', { shopCategoryId, no: true }),
    /**
     * 批量将多个商品设置成商品分类
     */
    batchCommodityShopCategory: model => request.post('batchCommodityShopCategory', model),
    /**
     * 店铺商品列表
     */
    commodityList: model => request.post('shop/commodityList', model, { no: true }),
    /**
     * 将商品移除分类
     */
    removeCommodityShopCategory: model => request.post('shop/removeCommodityShopCategory', model),
    /**
     * 查询优惠券关联的商品
     */
    discountCommodity: discountId => request.post('discountCommodity', { discountId }, { no: true }),
    /**
     * 订单列表
     */
    list: params => request.get('order/all/list', { params, no: true }),
    /**
     * 批量设置分类
     */
    batchSetCategory: model => request.put('shop/commodity/category/commodity/batch', model),
    /**
     * 移除分类
     */
    removeClass: id => request.delete('shop/commodity/category/commodity/' + id),
    /**
     * 活动列表
     */
    activiyList: model => request.post('activiyList', model, { no: true }),
    /**
     * 活动详情
     */
    activeDetails: activityId => request.post('activeDetails', { activityId }, { no: true }),
    /**
     * 添加活动
     */
    addActive: model => request.post('addActive', model),
    /**
     * 更新活动
     */
    editActive: model => request.post('editActive', model),
    /**
     * 订单收入明细
     */
    orderRecord: model => request.post('orderRecord', model, { no: true }),
    /**
     * 查询店铺信息
     */
    shopInfo: () => request.post('shopInfo', {}, { no: true }),
    /**
     * 提现记录
     */
    cashOutRecord: model => request.post('cashOutRecord', model, { no: true, noHandle: true }),
    /**
     * 其他配置
     */
    otherShopConfig: () => request.post('otherShopConfig', {}, { no: true }),
    /**
     * 添加提现记录
     */
    addCashOut: model => request.post('addCashOut', model, { no: true }),
    /**
     * 查询基本信息
     */
    getBusinessInfo: () => request.post('getBusinessInfo', {}, { no: true }),
    /**
     * 重置管理员密码
     */
    resetAdminPassword: model => request.post('resetAdminPassword', model),
    /**
     * 修改基础信息
     */
    commitBusinessInfo: model => request.post('commitBusinessInfo', model),
    /**
     * 保证金状态查询
     */
    cashProStatus: () => request.post('cashProStatus', {}, { no: true }),
    /**
     * 保证金记录
     */
    cashProRecord: model => request.post('cashProRecord', model, { no: true }),
    /**
     * 保证金缴纳/申请退款
     */
    cashProOperation: model => request.post('cashProOperation', model),
    /**
     * 更新其他配置
     */
    updateOtherShopConfig: model => request.post('updateOtherShopConfig', model),
    /**
     * 删除活动
     */
    removeActive: activityId => request.post('removeActive', { activityId }),
    /**
     * 活动上下架
     */
    activeStatus: model => request.post('activeStatus', model),
    /* ==================== 拼团 V2.0（NEW-08，16 个端点全部 POST） ==================== */
    /**
     * 拼团活动列表（本店，分页）
     */
    pinActivityList: model => request.post('pintuan/activity/list', model, { no: true }),
    /**
     * 新建拼团活动
     */
    pinActivitySave: model => request.post('pintuan/activity/save', model, { no: true }),
    /**
     * 编辑拼团活动（平台活动会被后端拒绝）
     */
    pinActivityUpdate: model => request.post('pintuan/activity/update', model, { no: true }),
    /**
     * 拼团活动详情（本店活动与平台活动都可读）
     */
    pinActivityDetail: activityId => request.post('pintuan/activity/detail', { activityId }, { no: true }),
    /**
     * 拼团活动上下架，data.groupCount 为在途团数
     */
    pinActivityStatus: model => request.post('pintuan/activity/status', model, { no: true }),
    /**
     * 平台拼团活动列表（shop_id=0，只读+报名，分页）
     */
    pinPlatformList: model => request.post('pintuan/platform/list', model, { no: true }),
    /**
     * 可报名商品与规格（分页，每行带 specList）
     */
    pinCommodityPool: model => request.post('pintuan/commodity/pool', model, { no: true }),
    /**
     * 选品报名（整批校验，任一行不合格全批不写）
     */
    pinCommodityApply: model => request.post('pintuan/commodity/apply', model, { no: true }),
    /**
     * 活动报名行列表（不分页，最新 100 条）
     */
    pinCommodityList: model => request.post('pintuan/commodity/list', model, { no: true, noHandle: true }),
    /**
     * 编辑报名行（拼团价/拼团库存/几人团/有效小时/排序）
     */
    pinCommodityUpdate: model => request.post('pintuan/commodity/update', model, { no: true }),
    /**
     * 报名行上下架，data.groupCount 为在途团数
     */
    pinCommodityStatus: model => request.post('pintuan/commodity/status', model, { no: true }),
    /**
     * 报名行移出活动（物理删除，已有团实例时后端拒绝）
     */
    pinCommodityRemove: model => request.post('pintuan/commodity/remove', model, { no: true }),
    /**
     * 本店团实例列表（不分页，最新 100 条）
     */
    pinGroupList: model => request.post('pintuan/group/list', model, { no: true, noHandle: true }),
    /**
     * 我的拼团订单（成员维度，分页）
     */
    pinOrderList: model => request.post('pintuan/order/list', model, { no: true }),
    /**
     * 平台跨店团实例列表（仅白名单店铺可调，不分页）
     */
    pinPlatformGroupList: model => request.post('pintuan/platform/group/list', model, { no: true, noHandle: true }),
    /**
     * 平台手动兜底成团（仅白名单店铺可调，id=团 id）
     */
    pinPlatformGroupForm: model => request.post('pintuan/platform/group/form', model, { no: true }),
    /**
     * 提现手续费
     */
    cashOutRate: () => request.post('cashOutRate', {}, { no: true }),
    /**
     * 统计详情
     */
    generalize: params => request.get('operation/generalize/details', { params, no: true }),
    /**
     * 获取是否有未读消息
     */
    unread: () => request.get('message/user/unread', { no: true }),
    /**
     * 获取商品分类
     */
    shopCategoryList: showType => request.get('shop/commodity/category/allList', { headers: { showType }, no: true }),
    /**
     * 获取区号
     */
    areaCode: () => request.get('areaCode', { no: true })
}